<!-- =========================================================================================
  File Name: DataListThumbView.vue
  Description: Data List - Thumb View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-thumb-view" class="data-list-container">
   <PartsAdmin v-show="this.$store.state.user.userGroup == 'admin'"/>
   <LaborAdmin v-show="this.$store.state.user.userGroup == 'admin'"/>
   <Parts v-show="this.$store.state.user.userGroup == 'funcionario'"/>
   <Labor v-show="this.$store.state.user.userGroup == 'funcionario'"/>
  </div>
</template>

<script>
import LaborAdmin from "./LaborAdmin";
import PartsAdmin from "./PartsAdmin";
import Labor from "./Labor";
import Parts from "./Parts";
export default {
  components: {
    LaborAdmin,
    PartsAdmin,
    Parts,
    Labor
  },
  data() {
    return {
      
    };
  },
  computed: {
   
  },
  methods: {
    
  },
  async created() {
    
   let payload = {
      loading: this.$vs.loading,
    };
    this.$store.dispatch("fetchAllUsers", payload);
  },
};
</script>

<style lang="scss">
</style>
